var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('b-tr',[_c('b-th',{staticClass:"text-center",attrs:{"rowspan":"6"}},[_vm._v("Profit")])],1),_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('b-table',{attrs:{"stacked":"md","items":_vm.profitInfo,"fields":_vm.fields,"head-row-variant":"success","thead-class":"d-none"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }